import React, { useMemo, useEffect, useState, useCallback } from 'react'
import { Text, View } from 'react-native'
import { observer } from 'mobx-react-lite'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { Trans, useTranslation } from 'react-i18next'
import { PROCESSING_STATUSES } from '@linqpal/models/src/dictionaries'
import { ArrowBlue, BlueTapeIconDark, InfoIcon } from '../../../../assets/icons'
import { ListItem } from '../../../../ui/atoms/builder-2.0/ListItem'

interface PropTypes {
  onPress?: () => void
  showInfo?: boolean
  amountLessThanMin?: boolean
  currentInvoiceCreditStatus: string | null
  disabled?: boolean
}

export const ApplyBTCreditItem_v2: React.FC<PropTypes> = observer(
  ({
    onPress,
    showInfo,
    amountLessThanMin = false,
    currentInvoiceCreditStatus,
    disabled,
  }) => {
    const { t } = useTranslation()
    const [textData, setTextData] = useState({
      info: t('payWithCreditButton.does-not-affect-credit-score'),
      subtitle: t('payWithCreditButton.no-fees'),
    })

    const title = useMemo(() => {
      if (PROCESSING_STATUSES.find((s) => s === currentInvoiceCreditStatus))
        return (
          <Text style={{ fontWeight: '600', fontSize: 16 }}>
            {t('payWithCreditButton.app-processing')}
          </Text>
        )
      else
        return (
          <Trans
            i18nKey="pay-with-btc"
            t={t}
            id={'pay-with-btc-title-container'}
          >
            <Text
              testID={'pay-with-bold-title'}
              style={{ fontWeight: '600', fontSize: 16 }}
            >
              Pay with
            </Text>{' '}
            <Text
              testID={'btc-title'}
              style={{ color: commonColors.accentText }}
            >
              BlueTape Credit
            </Text>{' '}
          </Trans>
        )
    }, [currentInvoiceCreditStatus, t])

    const updateTextData = useCallback(() => {
      if (amountLessThanMin) {
        setTextData({
          info: t('payWithCreditButton.min-amount-applicable'),
          subtitle: t('payWithCreditButton.not-eligible'),
        })
      }
    }, [amountLessThanMin, t])

    useEffect(() => {
      updateTextData()
    }, [updateTextData])

    return (
      <View testID={'pay-with-btc-container'}>
        <ListItem
          disabled={disabled}
          style={{
            alignSelf: 'center',
            backgroundColor: 'white',
            marginBottom: 0,
            height: 76,
            borderWidth: 1,
            borderColor: '#CCD6DD',
            borderRadius: 8,
            shadowColor: 'black',
            shadowOpacity: 0.06,
            shadowRadius: 10,
          }}
          otherStyles={{
            title: { fontWeight: '600', lineHeight: 22 },
            subTitle: { color: commonColors.textDark },
            frontIcon: { width: 34, height: 34, marginTop: 19 },
          }}
          onPress={onPress}
          icon={<BlueTapeIconDark />}
          endIcon={<ArrowBlue style={{ height: 25.2, width: 25.2 }} />}
          title={title}
          subtitle={textData.subtitle}
          testID={'apply-btc-item_v2'}
        />
        {showInfo && (
          <View
            testID={'btc-info-container'}
            style={{ flexDirection: 'row', marginTop: 5 }}
          >
            <InfoIcon style={{ alignSelf: 'center' }} />
            <Text
              testID={'btc-info-title'}
              style={{
                fontSize: 12,
                color: '#99ADBA',
                marginLeft: 8,
                fontWeight: '500',
              }}
            >
              {textData.info}
            </Text>
          </View>
        )}
      </View>
    )
  },
)
